export const animationSettings = {
  fs_end_popup: {
    'default': ['static', false],
    'ACTION:FS-END': ['play', false, 'in', { name: 'IN-END-DONE', delay: 1.5 }],
    'IN-END-DONE': ['play', true, 'idle'],
  },
  fs_start_popup: {
    'default': ['static', false],
    'ACTION:FS-START': ['play', false, 'in', { name: 'IN-START-DONE', delay: 1.5 }],
    'IN-START-DONE': ['play', true, 'idle', { type: 'mixin', from: 'idle', to: 'out', smooth: 0.4 }],
    'BUTTON:start': ['play', false, 'out', { name: 'BUTTON:startFreespin', delay: 0.8 }],
  },
}
